module.exports = __webpack_public_path__ + "static/media/iot.72dbcc51.jpg";